
import React from "react";
// import { Link, useNavigate } from 'react-router-dom';
// import images from "../nano-logo.png"
import './new_message.css';
function Header() {
    return (
      <nav>
        <div className="head">
          <h1>Cricket Q&A</h1>
          </div>
      </nav>
    );
  }
  

export default Header;